import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

// Pages
import Dashboard from './Dashboard';
import MemberManagement from './MemberManagement';
import BusinessDirectory from './BusinessDirectory';
import ReferralSystem from './ReferralSystem';
import ReviewTestimonals from './ReviewTestimonals';
import AddMembersForm from './AddMembersForm';
import EditMemberForm from './EditMember';
import BusinessManagement from './BusinessManagement';
import FamilyInformation from './FamilyInformation';
import EditFamily from './EditFamily';
import Category from './Category';
import AddBusinessForm from './AddBusinessForm';
import CommunityAdmin from './CommunityAdmin';
import AddCommunityAdmin from './AddCommunityAdmin';
import EditCommunityAdmin from './EditCommunityAdmin';

// Route Guard + Aurora shell
import ProtectedRoute from '../ProtectedRoute';
import { AppShell } from '../ui';

const guard = (el) => <ProtectedRoute type="admin">{el}</ProtectedRoute>;

const DashboardLayout = () => {
  const location = useLocation();
  const isLoginPage = location.pathname === '/admin';

  const routes = (
    <Routes>
      <Route path="" element={localStorage.getItem('adminToken')
        ? <Navigate to="dashboard" />
        /* Sign-in lives on the single /login page now, so the installed
           PWA has one entry point for every role. */
        : <Navigate to="/login?role=admin" replace />} />
      <Route path="dashboard" element={guard(<Dashboard />)} />
      <Route path="MemberManagement" element={guard(<MemberManagement />)} />
      <Route path="AddMembers" element={guard(<AddMembersForm />)} />
      <Route path="Category" element={guard(<Category />)} />
      <Route path="EditMember/:id" element={guard(<EditMemberForm />)} />
      <Route path="BusinessDirectory/:id" element={guard(<BusinessDirectory />)} />
      <Route path="AddBusinessDirectory/:id" element={guard(<AddBusinessForm />)} />
      <Route path="BusinessManagement" element={guard(<BusinessManagement />)} />
      <Route path="FamilyInformation" element={guard(<FamilyInformation />)} />
      <Route path="EditFamilyDetails/:id" element={guard(<EditFamily />)} />
      <Route path="ReferralSystem" element={guard(<ReferralSystem />)} />
      <Route path="ReviewTestimonals" element={guard(<ReviewTestimonals />)} />
      <Route path="CommunityAdmin" element={guard(<CommunityAdmin />)} />
      <Route path="CommunityAdmin/Add" element={guard(<AddCommunityAdmin />)} />
      <Route path="CommunityAdmin/Edit/:id" element={guard(<EditCommunityAdmin />)} />
      <Route path="ApplicationTracking" element={guard(<div>Application Tracking Page</div>)} />
      <Route path="Reports" element={guard(<div>Reports Page</div>)} />
    </Routes>
  );

  // The bare /admin login renders without the shell; everything else inside Aurora AppShell.
  if (isLoginPage) return routes;
  return <AppShell>{routes}</AppShell>;
};

export default DashboardLayout;
